import { crudEndpointsFactory } from "../crud-endpoints.factory";
import { IOrderCancelReason } from "@app/common";

export const orderCancelReasonApi = crudEndpointsFactory<IOrderCancelReason>()('order-cancel-reasons', 'OrderCancelReasons');
